import { get } from '../utils/axios'

export const getShiftsAPI = async () => {
  return await get('shifts')
}
